// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"dropdownMenu_dropdownMenu__evLVN","dropdownItem":"dropdownMenu_dropdownItem__66yqb"};